export const actions = {
  INVITE_USERS: 'INVITE_USERS',
  REVOKE_INVITE: 'REVOKE_INVITE',
  CHANGE_ROLE: 'CHANGE_ROLE',
  REVOKE_USER_ACCESS: 'REVOKE_USER_ACCESS',
  FETCH_USERS_LIST: 'FETCH_USERS_LIST',
  FETCH_USERS_LIST_V3: 'FETCH_USERS_LIST_V3',
  SAVE_USERS_LIST: 'SAVE_USERS_LIST',
  REMOVE_ALL_DATA: 'REMOVE_ALL_DATA',
  CSV_USER_DATA: 'CSV_USER_DATA',
  SAVE_UPDATED_MANAGER: 'SAVE_UPDATED_MANAGER',
  SAVE_RECENT_FOUNDER: 'SAVE_RECENT_FOUNDER',
  GET_FOUNDER_DETAILS_REQUEST: 'GET_FOUNDER_DETAILS_REQUEST',
  GET_FOUNDER_DETAILS_RESPONSE: 'GET_FOUNDER_DETAILS_RESPONSE',
  GET_DIRECT_REPORTS_IN_ORG_HIERARCHY_REQUEST:
    'GET_DIRECT_REPORTS_IN_ORG_HIERARCHY_REQUEST',
  GET_DIRECT_REPORTS_IN_ORG_HIERARCHY_RESPONSE:
    'GET_DIRECT_REPORTS_IN_ORG_HIERARCHY_RESPONSE',
  SET_SEARCH_HIERARCHY: 'SET_SEARCH_HIERARCHY',
  GET_DR_IN_SEARCH_HIERARCHY_REQUEST: 'GET_DR_IN_SEARCH_HIERARCHY_REQUEST',
  GET_DR_IN_SEARCH_HIERARCHY_RESPONSE: 'GET_DR_IN_SEARCH_HIERARCHY_RESPONSE',
  VALIDATE_HIERARCHY_REQUEST: 'VALIDATE_HIERARCHY_REQUEST',
  VALIDATE_HIERARCHY_RESPONSE: 'VALIDATE_HIERARCHY_RESPONSE',
  UPDATE_MANAGERS_REQUEST: 'UPDATE_MANAGERS_REQUEST',
  UPDATE_MANAGERS_RESPONSE: 'UPDATE_MANAGERS_RESPONSE',
  UPDATE_DESIGNATION_REQUEST: 'UPDATE_DESIGNATION_REQUEST',
  UPDATE_DESIGNATION_RESPONSE: 'UPDATE_DESIGNATION_RESPONSE',
  GET_L1LEADERS_REQUEST: 'GET_L1LEADERS_REQUEST',
  GET_L1LEADERS_RESPONSE: 'GET_L1LEADERS_RESPONSE',
  GET_FUNCTIONS_WITH_OWNER_REQUEST: 'GET_FUNCTIONS_WITH_OWNER_REQUEST',
  GET_FUNCTIONS_WITH_OWNER_RESPONSE: 'GET_FUNCTIONS_WITH_OWNER_RESPONSE',
  CREATE_FUNCTION_REQUEST: 'CREATE_FUNCTION_REQUEST',
  CREATE_FUNCTION_RESPONSE: 'CREATE_FUNCTION_RESPONSE',
  REMOVE_FUNCTION_REQUEST: 'REMOVE_FUNCTION_REQUEST',
  REMOVE_FUNCTION_RESPONSE: 'REMOVE_FUNCTION_RESPONSE',
  UPDATE_FUNCTION_OWNERS_REQUEST: 'UPDATE_FUNCTION_OWNERS_REQUEST',
  UPDATE_FUNCTION_OWNERS_RESPONSE: 'UPDATE_FUNCTION_OWNERS_RESPONSE',
  GET_DEMOGRAPHIC_MASTER_DATA_REQUEST: 'GET_DEMOGRAPHIC_MASTER_DATA_REQUEST',
  GET_DEMOGRAPHIC_MASTER_DATA_RESPONSE: 'GET_DEMOGRAPHIC_MASTER_DATA_RESPONSE',
  UPDATE_USER_DETAILS_REQUEST: 'UPDATE_USER_DETAILS_REQUEST',
  UPDATE_USER_DEMOGRAPHICS_REQUEST: 'UPDATE_USER_DEMOGRAPHICS_REQUEST',
  GET_ORG_DEMOGRAPHIC_KEYS: 'GET_ORG_DEMOGRAPHIC_KEYS',
  SAVE_ORG_DEMOGRAPHIC_KEYS: 'SAVE_ORG_DEMOGRAPHIC_KEYS',
  FILE_UPLOAD_USER_DATA: 'FILE_UPLOAD_USER_DATA',
  UPDATE_USER_ROLE: 'UPDATE_USER_ROLE',
  UPDATE_USER_IN_LIST: 'UPDATE_USER_IN_LIST',
  GET_ORG_SUBSCRIPTION_REQUEST: 'GET_ORG_SUBSCRIPTION_REQUEST',
  SAVE_ORG_SUBSCRIPTION_RESPONSE: 'SAVE_ORG_SUBSCRIPTION_RESPONSE',
  GET_HRBPS_LIST_REQUEST: 'GET_HRBPS_LIST_REQUEST',
  GET_HRBPS_LIST_RESPONSE: 'GET_HRBPS_LIST_RESPONSE',
  UPDATE_HRBP_LIST_REQUEST: 'UPDATE_HRBP_LIST_REQUEST',
  UPDATE_HRBP_LIST_RESPONSE: 'UPDATE_HRBP_LIST_RESPONSE',
  REMOVE_HRBP_LIST_REQUEST: 'REMOVE_HRBP_LIST_REQUEST',
  REMOVE_HRBP_LIST_RESPONSE: 'REMOVE_HRBP_LIST_RESPONSE',
  UPDATE_MANAGER_HRBPS_REQUEST: 'UPDATE_MANAGER_HRBPS_REQUEST',
  UPDATE_MANAGER_HRBPS_RESPONSE: 'UPDATE_MANAGER_HRBPS_RESPONSE',
  BULK_USER_INVITE_ASYNC: 'BULK_USER_INVITE_ASYNC',
  GET_ONGOING_USER_INVITE_STATUS: 'GET_ONGOING_USER_INVITE_STATUS',
  SAVE_ONGOING_USER_INVITE_STATUS: 'SAVE_ONGOING_USER_INVITE_STATUS',
  UPDATE_USER_MANAGER_DESIGNATION_DEMOGRAPHICS:
    'UPDATE_USER_MANAGER_DESIGNATION_DEMOGRAPHICS'
};

export const fetchUsersList = ({ burstCache = false } = {}) => ({
  type: actions.FETCH_USERS_LIST,
  burstCache
});

export const fetchUsersListV3 = ({
  burstCache = false,
  includeDemographics = false
} = {}) => ({
  type: actions.FETCH_USERS_LIST_V3,
  burstCache,
  includeDemographics
});

export const saveUsersList = (list, isUserDetailsV2 = false) => ({
  type: actions.SAVE_USERS_LIST,
  list,
  isUserDetailsV2
});

export const inviteUsers = (users, callback, sendEmailToggle = true) => ({
  type: actions.INVITE_USERS,
  users,
  callback,
  sendEmailToggle
});

export const revokeInvite = requestBody => ({
  type: actions.REVOKE_INVITE,
  requestBody
});

export const changeRole = (user_reference_id, role) => ({
  type: actions.CHANGE_ROLE,
  user_reference_id,
  role
});

export const revokeUserAccess = (requestBody, newOwner, userType) => ({
  type: actions.REVOKE_USER_ACCESS,
  requestBody,
  newOwner,
  userType
});

export const clearPeopleReducer = () => ({
  type: actions.REMOVE_ALL_DATA
});

export const saveCSVData = path => ({
  type: actions.CSV_USER_DATA,
  path
});

export const saveUpdatedManagerData = data => ({
  type: actions.SAVE_UPDATED_MANAGER,
  data
});

export const getFounderDetailsRequest = (expandL1 = false) => ({
  type: actions.GET_FOUNDER_DETAILS_REQUEST,
  expandL1
});

export const getFounderDetailsResponse = data => ({
  type: actions.GET_FOUNDER_DETAILS_RESPONSE,
  data
});

export const getDirectReportsInOrgHierarchyRequest = (
  user_reference_id,
  parent,
  viaSearch = false
) => ({
  type: actions.GET_DIRECT_REPORTS_IN_ORG_HIERARCHY_REQUEST,
  user_reference_id,
  parent,
  viaSearch
});

export const getDirectReportsInOrgHierarchyResponse = (
  user_reference_id,
  parent,
  data,
  viaSearch = false
) => ({
  type: actions.GET_DIRECT_REPORTS_IN_ORG_HIERARCHY_RESPONSE,
  user_reference_id,
  parent,
  data,
  viaSearch
});

export const setSearchHierarchy = data => ({
  type: actions.SET_SEARCH_HIERARCHY,
  data
});

export const validateHierarchyRequest = () => ({
  type: actions.VALIDATE_HIERARCHY_REQUEST
});

export const validateHierarchyResponse = data => ({
  type: actions.VALIDATE_HIERARCHY_RESPONSE,
  data
});

export const updateManagersRequest = users => ({
  type: actions.UPDATE_MANAGERS_REQUEST,
  users
});

export const updateManagersResponse = data => ({
  type: actions.UPDATE_MANAGERS_RESPONSE,
  data
});

export const updateDesignationRequest = users => ({
  type: actions.UPDATE_DESIGNATION_REQUEST,
  users
});

export const updateDesignationResponse = data => ({
  type: actions.UPDATE_DESIGNATION_RESPONSE,
  data
});

export const getL1LeadersRequest = () => ({
  type: actions.GET_L1LEADERS_REQUEST
});

export const getL1LeadersResponse = data => ({
  type: actions.GET_L1LEADERS_RESPONSE,
  data
});

export const getFunctionsWithOwnerRequest = () => ({
  type: actions.GET_FUNCTIONS_WITH_OWNER_REQUEST
});

export const getFunctionsWithOwnerResponse = data => ({
  type: actions.GET_FUNCTIONS_WITH_OWNER_RESPONSE,
  data
});

export const createFunctionRequest = (name, owner) => ({
  type: actions.CREATE_FUNCTION_REQUEST,
  name,
  owner
});

export const createFunctionResponse = data => ({
  type: actions.CREATE_FUNCTION_RESPONSE,
  data
});

export const removeFunctionRequest = (functionId, skipRemovalUpdate, cb) => ({
  type: actions.REMOVE_FUNCTION_REQUEST,
  functionId,
  skipRemovalUpdate,
  cb
});

export const removeFunctionResponse = data => ({
  type: actions.REMOVE_FUNCTION_RESPONSE,
  data
});

export const updateFunctionOwnersRequest = (
  functionOwnerMap,
  oldFunctionIds,
  cb
) => ({
  type: actions.UPDATE_FUNCTION_OWNERS_REQUEST,
  functionOwnerMap,
  oldFunctionIds,
  cb
});

export const updateFunctionOwnersResponse = data => ({
  type: actions.UPDATE_FUNCTION_OWNERS_RESPONSE,
  data
});

export const getDemographicMasterData = () => ({
  type: actions.GET_DEMOGRAPHIC_MASTER_DATA_REQUEST
});

export const saveDemographicMasterData = data => ({
  type: actions.GET_DEMOGRAPHIC_MASTER_DATA_RESPONSE,
  data
});

export const updateUserDemographicsRequest = (requestBody, callback) => ({
  type: actions.UPDATE_USER_DEMOGRAPHICS_REQUEST,
  requestBody,
  callback
});

export const getOrgDemographicKeys = () => ({
  type: actions.GET_ORG_DEMOGRAPHIC_KEYS
});

export const saveOrgDemographicKeys = data => ({
  type: actions.SAVE_ORG_DEMOGRAPHIC_KEYS,
  data
});

export const saveFileUploadData = (path, ext = '') => ({
  type: actions.FILE_UPLOAD_USER_DATA,
  path,
  ext
});

export const updateUserRole = requestBody => ({
  type: actions.UPDATE_USER_ROLE,
  requestBody
});

export const updateUserInList = user => ({
  type: actions.UPDATE_USER_IN_LIST,
  user
});

export const getOrgSubscriptionRequest = (callback = undefined) => ({
  type: actions.GET_ORG_SUBSCRIPTION_REQUEST,
  callback
});

export const saveOrgSubscriptionResponse = data => ({
  type: actions.SAVE_ORG_SUBSCRIPTION_RESPONSE,
  data
});

export const getHrbpsRequest = () => ({
  type: actions.GET_HRBPS_LIST_REQUEST
});

export const saveHrbpsResponse = data => ({
  type: actions.GET_HRBPS_LIST_RESPONSE,
  data
});

export const updateHrbpListRequest = (requestBody, toastMessage) => ({
  type: actions.UPDATE_HRBP_LIST_REQUEST,
  requestBody,
  toastMessage
});

export const updateHrbpListResponse = data => ({
  type: actions.UPDATE_HRBP_LIST_RESPONSE,
  data
});

export const removeHrbpListRequest = (requestBody, toastMessage) => ({
  type: actions.REMOVE_HRBP_LIST_REQUEST,
  requestBody,
  toastMessage
});

export const removeHrbpListResponse = data => ({
  type: actions.REMOVE_HRBP_LIST_RESPONSE,
  data
});

export const updateManagerHrbpsRequest = (
  managerId,
  requestBody,
  callback
) => ({
  type: actions.UPDATE_MANAGER_HRBPS_REQUEST,
  managerId,
  requestBody,
  callback
});

export const updateManagerHrbpsResponse = (managerId, data) => ({
  type: actions.UPDATE_MANAGER_HRBPS_RESPONSE,
  managerId,
  data
});

export const bulkUserInviteAsync = (
  users,
  callback,
  sendEmailToggle = true
) => ({
  type: actions.BULK_USER_INVITE_ASYNC,
  users,
  callback,
  sendEmailToggle
});

export const getOngoingUserInviteStatus = (callback = undefined) => ({
  type: actions.GET_ONGOING_USER_INVITE_STATUS,
  callback
});

export const saveOngoingUserInviteStatus = data => ({
  type: actions.SAVE_ONGOING_USER_INVITE_STATUS,
  data
});

export const updateUserManagerDesignationOrDemographics = (
  userAttributes,
  originalUserObject,
  allUsers,
  callback
) => ({
  type: actions.UPDATE_USER_MANAGER_DESIGNATION_DEMOGRAPHICS,
  userAttributes,
  originalUserObject,
  allUsers,
  callback
});
